import { v2Api } from './v2Client';

/** Catalogue des sports (ERP → Configuration → Sports) — administrateur (rôle 1). Les sports sont fixes
 * (Scripts/SeedSportCatalog.sql côté API) : ni création ni suppression. `update` ne modifie que les réglages du club
 * pour le sport : `is_active`, `color`, `sort_order`, `payment_mode` (online | on_site | all, règle de réservation
 * générique du sport), `cancellation_cutoff_minutes`, `doinsport_activity_id`, `default_scoring_format_id` (même effet
 * que scoringFormatService.setDefault). Nom, icône, joueurs par côté, arbitrage et libellés sont refusés. Un champ
 * absent / null reste inchangé. */
export const sportsAdminService = {
  list: () => v2Api.get('/Sport/admin_list').then((r) => (Array.isArray(r.data) ? r.data : [])),
  update: (body) => v2Api.post('/Sport/update', body).then((r) => r.data),
};

export const COURT_PAYMENT_MODE_OPTIONS = [
  ['online', 'En ligne'],
  ['on_site', 'Sur place'],
  ['all', 'Les deux'],
];
